import { useLibraryPostsGateway } from './LibraryPostsGatewayProvider';
import { getCommunityPostsV2PageQueryOptions } from '../api/queryOptions';
import type { LibraryListParams } from '../model/types';

import { useUserScopedQuery } from '@/hooks/useUserScopedQuery';

/** One page of the library list, which adjacent-post navigation reads to find a neighbour. */
export function useLibraryPage(params: LibraryListParams, { enabled }: { enabled: boolean }) {
  return useUserScopedQuery(
    getCommunityPostsV2PageQueryOptions,
    [params, useLibraryPostsGateway()],
    { enabled }
  );
}
